import type { AnalysisState } from '@aibi/contracts';
import { useCallback } from 'react';
import type { FieldDescriptor } from '../model/field-catalog';
import { useUiState } from './ui-state';
import { useWorkspace, useWorkspaceActions } from './workspace-context';

/** Tarjeta seleccionada (o `null` si no hay seleccion o ya no existe). */
export function useSelectedCard(): AnalysisState | null {
  const { document } = useWorkspace();
  const { selectedCardId } = useUiState();
  return document.cards.find((card) => card.id === selectedCardId) ?? null;
}

/**
 * Agrega un campo a la tarjeta seleccionada o, si no hay ninguna, crea una tarjeta nueva
 * con ese campo. Es la alternativa por teclado/clic al arrastre.
 */
export function useAddField(): (field: FieldDescriptor) => void {
  const card = useSelectedCard();
  const { execute } = useWorkspaceActions();
  const cardId = card?.id ?? null;
  return useCallback(
    (field: FieldDescriptor) => {
      execute(
        cardId === null
          ? { type: 'add-card', fieldIds: [field.id] }
          : { type: 'add-field', cardId, fieldId: field.id },
      );
    },
    [cardId, execute],
  );
}
